webpackJsonp([201781350822024],{

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Triangle = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1314wrb0'
	})('position:relative;background-color:orange;text-align:left;font-size:1rem;&:before,&:after{content:\'\';position:absolute;background-color:inherit;}width:10em;height:10em;&:before,&:after{width:10em;height:10em;border-top-right-radius:30%;}transform:rotate(-60deg) skewX(-30deg) scale(1,0.866);&:before{transform:rotate(-135deg) skewX(-45deg) scale(1.414,0.707) translate(0,-50%);}&:after{transform:rotate(135deg) skewY(-45deg) scale(0.707,1.414) translate(50%);}');
	
	exports.default = Triangle;
	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Triangle = __webpack_require__(81);
	
	var _Triangle2 = _interopRequireDefault(_Triangle);
	
	var _theme = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { htmlAdd } from '../util/htmlAdd';
	
	// import Html5YouTube from '../util/html5-youtube';
	// import YtScriptLoader from '../util/html5-youtube';
	
	//const init = false;
	
	var BaseDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e64v9e00'
	})('position:fixed;width:100%;height:100%;z-index:9997;top:0;background-color:black;');
	
	// const Iframe = styled.iframe`
	//   position: absolute;
	//   top: 0;
	//   z-index: 0;
	//   transition: 0.3s all;
	// `;
	
	//import Link from 'gatsby-link';
	//import { css } from 'react-emotion';
	var Img = /*#__PURE__*/(0, _reactEmotion2.default)('img', {
	  target: 'e64v9e01'
	})('position:fixed;top:0;z-index:98;width:100%;height:100%;transition:0.3s all;max-width:4000%;background-color:black;');
	
	var Tri = /*#__PURE__*/(0, _reactEmotion2.default)(_Triangle2.default, {
	  target: 'e64v9e02'
	})('transform:rotate(45deg) scale(0.15);background-color:', _theme.theme.set.dark.invertWhite, ';top:-4.8rem;left:-3.95rem;z-index:99;opacity:0.65;transition:', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';');
	var BgTri = /*#__PURE__*/(0, _reactEmotion2.default)(_Triangle2.default, {
	  target: 'e64v9e03'
	})('transform:rotate(45deg) scale(0.2);background-color:', function (props) {
	  return props.theme.set.dark.bgText;
	}, ';top:-14.75rem;left:-3.95rem;z-index:98;opacity:0.87;transition:', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';');
	var ShadowTri = /*#__PURE__*/(0, _reactEmotion2.default)(_Triangle2.default, {
	  target: 'e64v9e04'
	})('transform:rotate(45deg) scale(0.23);background-color:', function (props) {
	  return props.theme.colors.cool.lead;
	}, ';top:-24.72rem;left:-4rem;z-index:97;opacity:0.55;transition:', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';');
	var TriDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e64v9e05'
	})('z-index:99;position:fixed;left:50%;top:50%;@media (min-width:1920px){left:30%;top:30%;}');
	
	var Clicker = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e64v9e06'
	})('width:100%;position:fixed;&:focus,&:hover{cursor:pointer;', Img, '{width:112%;height:112%;margin-left:-6%;margin-top:-6%;}', Tri, '{background-color:', function (props) {
	  return props.theme.colors.warm.fade;
	}, ';opacity:1;}', BgTri, '{opacity:1;}', ShadowTri, '{opacity:0.65;}}');
	
	var id = '';
	var vid = '';
	var img = '';
	var b1x1 = '';
	var clicked = false;
	// 11 chars per (12 with separator).
	
	var fixImg = function fixImg(imgId) {
	  document.getElementById(imgId).src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
	};
	
	// const load = () => {
	//   //document.getElementById('HeadroomWrapDiv').style.display = 'none';
	//   document.getElementById(`baseDiv_${id}`).style.background = 'transparent';
	// };
	
	var handleSubmit = function handleSubmit(e) {
	  if (!clicked) {
	    document.getElementById('img_' + id).style.display = 'none';
	    document.getElementById('playMedia_' + id).style.display = 'none';
	    if (typeof window !== 'undefined') {
	      //window.location = `${vid}controls=1;loop=1;showinfo=0;modestbranding=1;disablekb=1;enablejsapi=1;html5=1;playlist=${id};`;
	      //window.location = `${vid}loop=1;`;
	      //window.location = `${vid}?enablejsapi=1;autoplay=1;loop=1;controls=1;showinfo=0;modestbranding=1;disablekb=1;`;
	      window.location = vid + '?autoplay=1;&mute=1;enablejsapi=1;controls=1;showinfo=0;modestbranding=1;disablekb=1;';
	
	      console.log('' + vid);
	    }
	    clicked = true;
	  }
	};
	
	var Vid = function Vid(_ref) {
	  var type = _ref.type;
	
	  if (typeof window !== 'undefined') {
	    // if (window.location.pathname.length === 27) {
	    //id = window.location.pathname.substring(16, window.location.pathname.length);
	    id = window.location.hash.substring(1, window.location.hash.length);
	    img = window.location.hostname;
	    //vid = `//www.youtube-nocookie.com/embed/${id}?autoplay=1;enablejsapi=1;html5=1;`;
	    //vid = `https://youtube.com/embed/${id}?autoplay=1;enablejsapi=1;html5=1;`;
	    vid = 'https://www.youtube-nocookie.com/embed/' + id;
	
	    // alert(window.location.pathname);
	  }
	  if (img.match('localhost')) {
	    img = img + ':8000';
	  }
	
	  b1x1 = '//' + img + '/img/iframe/';
	
	  //img = `${b1x1}/${id}.jpg`;
	  img = b1x1 + '/' + id + '.webp';
	
	  b1x1 = b1x1 + '1b.gif';
	
	  // alert(`id:${id} | vid:${vid}`);
	
	  // const baseDivClass = '';
	  // className={css(baseDivClass)}
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      Clicker,
	      { id: 'clicker_' + id, onClick: function onClick(e) {
	          return handleSubmit(e);
	        }, rel: 'noopener noreferrer' },
	      _react2.default.createElement(
	        TriDiv,
	        { id: 'playMedia_' + id },
	        _react2.default.createElement(Tri, null),
	        _react2.default.createElement(BgTri, null),
	        _react2.default.createElement(ShadowTri, null)
	      ),
	      _react2.default.createElement(Img, { id: 'img_' + id, src: img, onError: function onError(e) {
	          return fixImg('img_' + id);
	        } })
	    )
	  );
	  /*
	      return (
	    <React.Fragment>
	      <Clicker id={`clicker_${id}`} onClick={e => handleSubmit(e)}>
	        <BaseDiv id={`baseDiv_${id}`}>
	          <TriDiv id={`playMedia_${id}`}>
	            <Tri />
	            <BgTri />
	            <ShadowTri />
	          </TriDiv>
	          <Img id={`img_${id}`} src={img} onError={e => fixImg(`img_${id}`)} />
	        </BaseDiv>
	      </Clicker>
	    </React.Fragment>
	  );
	  
	  return (
	    <React.Fragment>
	      <Img id={`b1x1_${id}`} src={b1x1} style={{ opacity: `0`, zIndex: `0` }} onLoad={e => preload()} />
	      <Clicker id={`clicker_${id}`} onClick={e => handleSubmit(e)}>
	        <BaseDiv id={`baseDiv_${id}`}>
	          <TriDiv id={`playMedia_${id}`}>
	            <Tri />
	            <BgTri />
	            <ShadowTri />
	          </TriDiv>
	          <Img id={`img_${id}`} src={img} onError={e => fixImg(`img_${id}`)} onLoad={e => load()} />
	          <Iframe
	            id={`iframe_${id}z`}
	            width="100%"
	            height="100%"
	            scrolling="no"
	            muted
	            allow="autoplay"
	            autoplay="yes"
	            frameBorder="0"
	            allowFullScreen
	          />
	        </BaseDiv>
	      </Clicker>
	    </React.Fragment>
	  );
	  */
	};
	
	exports.default = _react2.default.memo(Vid);
	
	
	Vid.propTypes = {
	  type: _propTypes2.default.string
	};
	
	Vid.defaultProps = {
	  type: ''
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-vid-jsx-b9092dd6e1c58849b0f4.js